import { getInitData } from '@/utils/getInitData';
import { settings } from '../api/config';
import axios from 'axios';
export const richAdsClickSend = async () => {
  if (!getInitData()) {
    throw new Error('initData отсутствует');
  }
  const initData = encodeURIComponent(getInitData());
  const url = `${settings.url}api/banners/richads/click?initData=${initData}`;

  console.log('[RICHADS] POST:', url);

  try {
    const response = await axios.post(url);
    // await handleFlyerCpcCheckOnBack(campaignId);
    console.log('[RICHADS] POST response:', response);
    return response.data;
  } catch (error) {
    console.error('[RICHADS] Claim error:', error);
    throw error;
  }
};
